import { Button } from '@mui/material'
import { Box } from '@mui/system'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { queryClient } from '../../../../../App'
import lupeWhiteIcon from '../../../../../assets/images/common/lupeWhite.svg'
import {
  isAdministration,
  isOperator,
} from '../../../../../services/AccountService'
import ToGuaranteeRepair from '../DrawersCommonComponents/Buttons/ToGuaranteeRepair'

const DrawerButtons = ({ serviceStore, subscriberReason }) => {
  const {
    showContinueInfo,
    showAddServiceRequestForm,
    haveNotFound,
    searchByPhoneMode,
    searchByIdMode,
    getInstalledOrders,
    toggleToShowContinueInfo,
    toggleOnPhoneSearchMode,
    showAddServiceRequestFormFunc,
    onCloseDrawer,
    createServiceOrder,
    checkedSeviceOrder,
    installedOrders,
    showToggleToPhoneBtn,
    equipmentIdError,
    serviceAddRequestFormStore,
    goOnStartDrawer,
    setShowRequestPreview,
    showRequestPreview,
  } = serviceStore

  const disabledSaveBtn =
    serviceAddRequestFormStore.data.requireReasonDiscription &&
    !serviceAddRequestFormStore.data.malfunctionExplanation

  const wrongReason = isOperator() && !subscriberReason

  const incedentTypes = queryClient.getQueryData(['incedent-types'])
  const incedentTypeReasons = queryClient.getQueryData([
    'incedent-type-reasons',
  ])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '0 16px',
        marginTop: '14px',
        paddingBottom: '40px',
      }}
    >
      {searchByIdMode &&
        !showContinueInfo &&
        !showAddServiceRequestForm &&
        !checkedSeviceOrder && (
          <Button
            fullWidth
            variant={'contained'}
            onClick={getInstalledOrders}
            startIcon={
              <img
                style={{ marginRight: '8px' }}
                src={lupeWhiteIcon}
                alt='search icon'
              />
            }
            disabled={searchByIdMode && equipmentIdError}
          >
            найти данные по Id оборудования
          </Button>
        )}
      {!haveNotFound &&
        !showAddServiceRequestForm &&
        !showContinueInfo &&
        !installedOrders.length &&
        !showToggleToPhoneBtn &&
        !searchByPhoneMode && (
          <Button
            fullWidth
            variant={'outlined'}
            onClick={toggleOnPhoneSearchMode}
            disabled={isAdministration()}
          >
            id не предоставлен
          </Button>
        )}
      {searchByPhoneMode && !checkedSeviceOrder && (
        <Button
          fullWidth
          variant={'contained'}
          onClick={getInstalledOrders}
          disabled={serviceAddRequestFormStore.data.phoneNumber?.length !== 18}
        >
          найти данные по номеру телефона
        </Button>
      )}
      {searchByIdMode && !installedOrders.length && haveNotFound && (
        <Button
          fullWidth
          variant={'outlined'}
          onClick={toggleOnPhoneSearchMode}
        >
          поиск по номеру телефона
        </Button>
      )}
      {searchByPhoneMode && !installedOrders.length && (
        <Button
          fullWidth
          variant={'outlined'}
          onClick={toggleToShowContinueInfo}
          disabled={!haveNotFound}
        >
          поиск не дал результатов
        </Button>
      )}
      {showContinueInfo && (
        <Button
          fullWidth
          variant={'contained'}
          onClick={showAddServiceRequestFormFunc}
        >
          Продолжить
        </Button>
      )}
      {showAddServiceRequestForm && (isOperator() || isAdministration()) && (
        <Button
          fullWidth
          variant={'contained'}
          onClick={() => setShowRequestPreview(true)}
          disabled={
            !serviceAddRequestFormStore.isValid ||
            disabledSaveBtn ||
            wrongReason
          }
        >
          Продолжить
        </Button>
      )}
      {checkedSeviceOrder &&
        installedOrders.length &&
        !showAddServiceRequestForm &&
        !showRequestPreview && (
          <Button
            fullWidth
            variant={'contained'}
            onClick={() => showAddServiceRequestFormFunc()}
          >
            Создать на основе заявки № {checkedSeviceOrder.orderId}
          </Button>
        )}
      {showAddServiceRequestForm && !isOperator() && !isAdministration() && (
        <Button
          fullWidth
          variant={'contained'}
          onClick={createServiceOrder}
          disabled={!serviceAddRequestFormStore.isValid}
        >
          Создать заявку на обслуживание
        </Button>
      )}
      {showRequestPreview && (
        <>
          <Button
            fullWidth
            variant={'contained'}
            onClick={() =>
              createServiceOrder(incedentTypes, incedentTypeReasons, true)
            }
          >
            Решена дистанционно
          </Button>
          <Button
            fullWidth
            variant={'contained'}
            onClick={() =>
              createServiceOrder(incedentTypes, incedentTypeReasons)
            }
          >
            Не решена дистанционно
          </Button>
          {isOperator() && (
            <ToGuaranteeRepair
              currentServiceData={serviceAddRequestFormStore.data}
            />
          )}
          <Button
            fullWidth
            variant={'outlined'}
            onClick={() => showAddServiceRequestFormFunc(null, true)}
          >
            Отмена
          </Button>
        </>
      )}
      {(showAddServiceRequestForm ||
        showContinueInfo ||
        showAddServiceRequestForm) && (
        <Button fullWidth variant={'outlined'} onClick={onCloseDrawer}>
          Отмена
        </Button>
      )}
      {installedOrders.length !== 0 &&
        !showAddServiceRequestForm &&
        !showRequestPreview && (
          <Button fullWidth variant={'outlined'} onClick={goOnStartDrawer}>
            сбросить данные
          </Button>
        )}
    </Box>
  )
}

export default inject('serviceStore')(observer(DrawerButtons))
